module.exports = __webpack_public_path__ + "img/artist.d7f8b26e.svg";